import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { ExtraChargeTranslationFragment } from "@saleor/fragments/types/ExtraChargeTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import { LanguageCodeEnum } from "@saleor/types/globalTypes";
import React from "react";
import { useIntl } from "react-intl";

import TranslationFields from "../TranslationFields";

export interface TranslationsExtraChargesPageProps
  extends TranslationsEntitiesPageProps {
  extraCharge: ExtraChargeTranslationFragment;
}

export const fieldNames = {
  name: "name",
  desc: "desc",
  subName: "subName",
  subDesc: "subDesc"
};

const TranslationsExtraChargesPage: React.FC<TranslationsExtraChargesPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  extraCharge,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage:
              'Translation ExtraCharge "{extraChargeName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            extraChargeName: maybe(() => extraCharge.name, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "ExtraCharge Name"
            }),
            name: fieldNames.name,
            translation: maybe(() =>
              extraCharge.translation ? extraCharge.translation.name : null
            ),
            type: "short" as "short",
            value: maybe(() => extraCharge.name)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage({
          defaultMessage: "Search Engine Preview"
        })}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Desc"
            }),
            name: fieldNames.desc,
            translation: maybe(() =>
              extraCharge.translation ? extraCharge.translation.desc : null
            ),
            type: "long" as "long",
            value: maybe(() => extraCharge.desc)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Search Sub Name"
            }),
            name: fieldNames.subName,
            translation: maybe(() =>
              extraCharge.translation ? extraCharge.translation.subName : null
            ),
            type: "short" as "short",
            value: maybe(() => extraCharge.subName)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Search Sub Desc"
            }),
            name: fieldNames.subDesc,
            translation: maybe(() =>
              extraCharge.translation ? extraCharge.translation.subDesc : null
            ),
            type: "long" as "long",
            value: maybe(() => extraCharge.subDesc)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
    </Container>
  );
};
TranslationsExtraChargesPage.displayName = "TranslationsExtraChargesPage";
export default TranslationsExtraChargesPage;
